module.exports = __webpack_public_path__ + "static/media/strimko.f956f90c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/strimko.png
// module id = 71
// module chunks = 0